import { formatTooltipValueForSelectedMeasure } from '../ChartOptions/Format/NumberFormatter';
import { getUidOfKey } from '../CommonFunctions/CommonFunctions';

export function tooltipStyle(
  color: string,
  _data: any,
  tooltipFormats: any,
  chartAxes: any,
  dimensionDisplayNames?: string | string[],
  thirdName?: string,
  percent?: string,
  fontFamily?: string,
) {
  const splitByAxis = chartAxes.find((axis: any) => axis.name === 'Split By');
  const splitByFieldName = splitByAxis?.fields?.[0]?.displayname;
  const style = fontFamily ? `font-family: ${fontFamily};` : '';

  if (Object.keys(_data).length === 0) {
    return `
     <div class="tooltipContainer " style="${style}">
      <div class="tooltip-data">
        <div class="tooltip-row">
          <div style="color: #999; padding-inline:16px;">No tooltip available</div>
        </div>
      </div>
    </div>`;
  } else {
    return `
    <div class="tooltipContainer" style="${style}">
      <div class="tooltip-data">
        ${Object.keys(_data)
          .map((key) => {
            let colorDot = splitByFieldName
              ? key === splitByFieldName && color
                ? `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};"></span>`
                : ''
              : dimensionDisplayNames &&
                  dimensionDisplayNames.length > 0 &&
                  dimensionDisplayNames.includes(key) &&
                  color
                ? `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};"></span>`
                : '';
            const showPercent = key === thirdName;

            const currentUid = getUidOfKey(chartAxes, key, tooltipFormats);

            let formattedKey = formatTooltipValueForSelectedMeasure(
              currentUid,
              tooltipFormats,
              _data[key],
            );
            return `
          <div class="tooltip-row">
            <div class="tooltip-key" style="${style}">${key}</div>
              <div class="tooltip-colon">:&nbsp;</div>
                <div class="tooltip-value" style="${style}">
                  <span>${colorDot}</span>
                  <span>
                  ${formattedKey}
                  ${showPercent ? percent : ''}
                  </span>
                </div>
            </div>`;
          })
          .join('')}
        </div>
      </div>
    `;
  }
}
